import { component as defineComponent } from 'flightjs';

export default defineComponent(function () {
    this.attributes({
        conditionalItem: '[data-conditional]',
        filterNameAttr: 'data-conditional-options-filter',
    });

    this.after('initialize', function () {
        this.on(document, 'uiBrowseFilterConditionChanged', this.toggleFilterOptions);
    });

    this.toggleFilterOptions = function (e, data) {
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var items;

        if (data.hasOwnProperty(fieldName)) {
            items = this.select('conditionalItem');
            items.each(function (i) {
                if (items.eq(i).attr('data-conditional') === data[fieldName]) {
                    items.eq(i).removeAttr('data-disabled');
                    items.eq(i).removeAttr('data-button-disabled');
                } else {
                    items.eq(i).attr('data-disabled', true);
                    items.eq(i).attr('data-button-disabled', true);
                }
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/conditional-options-filter.js